module.exports = __webpack_public_path__ + "img/glagCalssIntroduce.639fa41a.jpg";